import { render } from "./AddNewItem.vue?vue&type=template&id=35809f0f"
import script from "./AddNewItem.vue?vue&type=script&lang=js"
export * from "./AddNewItem.vue?vue&type=script&lang=js"

import "./AddNewItem.vue?vue&type=style&index=0&id=35809f0f&lang=css"

import exportComponent from "D:\\courses\\Web Design\\JAVA  SCRIPT\\Vue-js courses\\resturant\\mat-aem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__